export type TDrawerPanelSize = string;

export interface IDrawerSystemPanels {
    Bottom?: { LeftMargin: TDrawerPanelSize; RightMargin: TDrawerPanelSize; FrontMargin: TDrawerPanelSize; BackMargin: TDrawerPanelSize };
    Back?: { LeftMargin: TDrawerPanelSize; RightMargin: TDrawerPanelSize; BackMargin: TDrawerPanelSize; Height: TDrawerPanelSize };
}

export interface IDrawerSystemPart {
    Role: string;
    NominalLength?: number;
    ExtensionLength?: number;
    HardwareProduct: string;
    Offset?: [number, number, number];
    Alignment?: string[];
}

interface IDrawerSystem {
    ID: string;
    Name: string;
    Manufacturer: string;
    Series: string;
    LoadCapacity: number | null;
    SideKind: string | null;
    SideHeight: number | null;
    RequiredHeight: number | null;
    BottomOffset: number | null;
    SupportedThickness: number[];
    MinDepthAllowance: number | null;
    FixingLineHeight: number | null;
    FrontSetback: number | null;
    Panels: IDrawerSystemPanels;
    Parts: IDrawerSystemPart[];
}

export default IDrawerSystem;
